import { connect } from 'react-redux'
import { Action, Dispatch } from 'redux'
import AccountSwitcher from '../components/AccountSwitcher'
import { RootState } from '../types'
import { selectAccount } from '../actions'
import { setLocale } from 'react-redux-i18n'
import { MT4Connector } from '@bdswiss/mt4-connector'

const mt4 = MT4Connector.Instance

export function mapStateToProps(rootState: RootState) {
  const state = rootState.appState
  return {
    accountLoaded: state.accountLoaded,
    activeId: state.activeAccount,
    accounts: rootState.tradingAccounts.viewer.accounts,
    loginInfo: mt4.account, // rootState.tradingAccount,
    locale: rootState.appConfig.locale
      ? rootState.appConfig.locale
      : rootState.tradingAccounts.viewer.locale,
  }
}

export function mapDispatchToProps(dispatch: Dispatch<Action>) {
  return {
    onSelect: (accountId: string, id: number) => {
      dispatch(selectAccount(accountId, id))
    },

    setLocale: (locale: string) => dispatch(setLocale(locale) as any),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AccountSwitcher)
